import { watchSecurityServiceRequests } from './SecurityServiceSagas';
import { watchProcessRequests } from './ProcessServiceSagas';
import { watchDodRequests } from './DodServiceSagas';
import { watchSiteFacilitiesRequests } from './SiteFacilitiesServiceSagas';
import { watchContactServiceRequests } from './ContactServiceSagas';
import { watchDatastreamExplorerRequests } from './DataExplorerServiceSagas';
import { watchRecommendedDataRequests } from './RecommendedDataSaga';

export default function* rootSaga() {
    yield [
        watchSecurityServiceRequests(),
        watchProcessRequests(),
        watchDodRequests(),
        watchSiteFacilitiesRequests(),
        watchContactServiceRequests(),
        watchDatastreamExplorerRequests(),
        watchRecommendedDataRequests()
    ];

}



// WEBPACK FOOTER //
// ./src/services/sagas/RootSaga.js